<template>
  <div class="step-question-template blood-pressure-step-question">
    <div class="question-text">
      Have you tried a medication containing 'triptans' such as Imitrex (Sumatriptan), Maxalt (Rizatriptan), Zomig
      (Zolmitriptan) in the past?
    </div>
    <YesNo v-model="hasTriedTriptans" :yes="true" :no="false" id="has-tried-triptans" />
    <div class="question-error" v-if="hasTriedTriptansMessage">
      {{ hasTriedTriptansMessage }}
    </div>

    <div v-if="hasTriedTriptans">
      <div class="sub-question-text">
        Have you experienced relief when taking medication containing 'triptans' such as Imitrex (Sumatriptan), Maxalt
        (Rizatriptan), Zomig (Zolmitriptan)?
      </div>
      <YesNo
        v-model="hasExperiencedRelief"
        :yes="true"
        :no="false"
        id="has-experienced-relief"
        style="margin-top: 20px"
      />
      <div class="question-error" v-if="hasExperiencedReliefMessage">
        {{ hasExperiencedReliefMessage }}
      </div>

      <div v-if="!!hasExperiencedRelief || hasExperiencedRelief == false">
        <div class="sub-question-text">
          When you have taken a 'triptan' medication in the past, within the first few hours of taking it have you
          experienced sensations such as heaviness, pressure or tightness in the body (especially chest or throat), or
          have you experienced palpitations, flushing, dizziness, rash, a feeling of weakness, worsening nausea and
          vomiting or a temporary rise in your blood pressure?
        </div>
        <YesNo
          v-model="hasExperiencedSideEffects"
          :yes="true"
          :no="false"
          id="has-experienced-side-effects"
          style="margin-top: 20px"
        />
        <div class="question-error" v-if="hasExperiencedSideEffectsMessage">
          {{ hasExperiencedSideEffectsMessage }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import poster from "../mixins/poster";
import responseAdapters from "../mixins/responseAdapters";
import YesNo from "./YesNo.vue";

export default Vue.extend({
  mixins: [poster],
  inject: ["isUs", "submitUrl", "csrfHeader", "csrf"],
  components: {
    YesNo,
  },
  props: {
    question: { required: true },
    showRequired: { required: true },
    first: { required: true },
  },
  created() {
    this.$emit("answer", this.question, this.responseAdapter(this.question));

    if (this.isUs) {
      if (this.hasTriedTriptans != null) {
        this.$emit("update-next-button-status", true, !this.isCorrect);
      }
    }
  },
  data() {
    return {
      hasTriedTriptans: this.question.hasTriedTriptans,
      hasExperiencedRelief: this.question.hasExperiencedRelief,
      hasExperiencedSideEffects: this.question.hasExperiencedSideEffects,
      responseAdapter: responseAdapters.previousMigraineTreatment,
    };
  },
  computed: {
    hasTriedTriptansMessage() {
      return this.showRequired && this.hasTriedTriptans === null
        ? "You must answer this question to continue"
        : undefined;
    },
    hasExperiencedReliefMessage() {
      if (this.showRequired && this.hasTriedTriptans && this.hasExperiencedRelief === null) {
        return "You must answer this question to continue";
      }
      return undefined;
    },
    hasExperiencedSideEffectsMessage() {
      if (this.showRequired && this.hasTriedTriptans && this.hasExperiencedSideEffects === null) {
        return "You must answer this question to continue";
      }
      return undefined;
    },
    complete() {
      return (
        this.hasTriedTriptans === false ||
        (this.hasTriedTriptans === true &&
          (this.hasExperiencedRelief === true || this.hasExperiencedRelief === false) &&
          (this.hasExperiencedSideEffects === true || this.hasExperiencedSideEffects === false))
      );
    },
    isCorrect() {
      return !(this.hasTriedTriptans && this.hasExperiencedSideEffects);
    },
  },
  watch: {
    hasTriedTriptans() {
      this.question.hasTriedTriptans = this.hasTriedTriptans;
      this.$emit("has-tried-triptans-changed");

      if (this.complete) {
        this.post(this.responseAdapter(this.question));
      }

      if (this.isUs) {
        this.$emit("update-next-button-status", true, !this.isCorrect);
      }
    },
    hasExperiencedRelief() {
      this.question.hasExperiencedRelief = this.hasExperiencedRelief;
      if (this.complete) {
        this.post(this.responseAdapter(this.question));
      }
    },
    hasExperiencedSideEffects() {
      this.question.hasExperiencedSideEffects = this.hasExperiencedSideEffects;
      if (this.complete) {
        this.post(this.responseAdapter(this.question));
      }
      if (this.isUs) {
        this.$emit("update-next-button-status", true, !this.isCorrect);
      }
    },
  },
});
</script>
